export default __webpack_public_path__ + "static/media/LogoEBD.3d78e5d2.png";